export default "/kiban/_next/static/images/titleWithCouponApplied-6e668b387dc50da75f61f17ada605a00.png";